import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, Badge
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';

import { env } from '../env';
import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';

import { BerichtErstellen } from './BerichtErstellenComp';

type State = {
    ready: boolean;
}

type Props = {
    kunde: number | undefined,
    gemeinde: number | undefined,
    jahr: number | undefined,
    modul: number,
    verwaltungsansicht: boolean,
    plantyp: number,
    planstufe: number,
    uhconfig: number | undefined,
    plantypvgl: number,
    planstufevgl: number,
    planstufeJR: number,
    jahrJR: number,
    token: string,
    bundesland: string,
    buchungsart: number,
    berichtDialogOpen: boolean,
    berichtErstellenAnzeigen: boolean,
    designMode?: boolean,
    onBerichtKlick: () => void,
    onBerichtDialogClose: () => void
}



export class Dokumente extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.doktree = undefined;
    }

    node: any;
    doktree: KSLPlusAPI.DokTreeModel | undefined;

    state: State = {
        ready: false
    }


    componentDidMount() {
        this.readData();
    }

    readData = () => {
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        jahr = this.props.jahr;
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.dokumenttree(kunde, gemeinde, jahr, this.props.modul, this.props.verwaltungsansicht, "").then((doktree) => {
            this.doktree = doktree;
            this.setState({ ready: true });
        }).catch(Reason => {
        });


    }

    createTreeItems = (doktree: KSLPlusAPI.DokTreeModel[], id: string) => {
        var items = Object.keys(doktree).map((key, index) => {
            const item = Number(key);
            const dtm = doktree[key as any];

            if (!dtm.dokOrdner || !dtm.dokOrdner.bezeichnung)
                return null;

            const nid = id + "_" + item;
            var subItems: (JSX.Element | null)[] = [];

            if (dtm.unterordner != null)
                subItems = this.createTreeItems(dtm.unterordner, nid);

            if (dtm.dokumente != null)
                subItems = subItems.concat(this.createDocLinks(dtm.dokumente, nid));

            return (
                <TreeItem nodeId={nid} label={dtm.dokOrdner.bezeichnung} key={key}>
                    {subItems.find(s => s != null) ? subItems : null}
                </TreeItem>
            );
        });
        return items;
    };

    createDocLinks = (dokumente: KSLPlusAPI.Dokumente[], id: string) => {
        var items = Object.keys(dokumente).map((key, index) => {
            const item = Number(key);
            const dok = dokumente[key as any];

            if (!dok.url || !dok.bezeichnung)
                return null;

            const nid = id + "_" + item;

            return (
                <TreeItem nodeId={nid} label={dok.bezeichnung} onClick={() => this.handleTreeClick(dok)} key={key}
                    icon={dok.typ == 0 ? <Badge className="kslplus-info-badge ">i</Badge> : null}
                >

                </TreeItem>
            );
        });
        return items;
    };

    replaceUrlPlaceholders = (url: string) => {
        url = url.replace("{@jahr}", String(this.props.jahr ?? 0));
        url = url.replace("{@plantyp}", String(this.props.plantyp ?? 0));
        url = url.replace("{@planstufe}", String(this.props.planstufe ?? 0));
        url = url.replace("{@plantypvgl}", String(this.props.plantypvgl ?? 0));
        url = url.replace("{@planstufevgl}", String(this.props.planstufevgl ?? 0));
        url = url.replace("{@planstufeJR}", String(this.props.planstufeJR ?? 0));
        url = url.replace("{@jahrJR}", String(this.props.jahrJR ?? 0));
        url = url.replace("{@uhconfig}", String(this.props.uhconfig ?? 0));
        return url;
    }

    getToken = () => {
        if (this.props.token)
            return this.props.token;
        var stored = localStorage.getItem("KSLPlusAdmin_Token");
        if (stored)
            return "Bearer " + stored;
        return "";
    }

    handleTreeClick = (dok: KSLPlusAPI.Dokumente) => {
        var token = this.getToken();
        let url = this.replaceUrlPlaceholders(dok.url ?? "");

        if (dok.typ === 6 || dok.typ === 7) {
            if (!token) {
                this.props.onBerichtKlick();
                return;
            }
            fetch(url, {
                headers: { "Authorization": token }
            }).then(r => {
                if (r.status === 401) {
                    this.props.onBerichtKlick();
                    throw new Error("Unauthorized");
                }
                if (r.ok)
                    return r.blob();
                throw new Error("Status " + r.status);
            }).then(b => {
                if (b) {
                    var ext = dok.typ === 6 ? ".pdf" : ".docx";
                    var a = document.createElement("a");
                    a.href = URL.createObjectURL(b);
                    a.download = (dok.bezeichnung ?? "Bericht") + ext;
                    a.click();
                    URL.revokeObjectURL(a.href);
                }
            }).catch(() => { });
        } else {
            window.open(url, "_blank");
        }
    }

    render() {
        if (!this.state.ready)
            return null;

        var treeitems = this.createTreeItems(this.doktree && this.doktree.unterordner ? this.doktree.unterordner : [], "1")
        var docitems = this.createDocLinks(this.doktree && this.doktree.dokumente ? this.doktree.dokumente : [], "1")
        return (
            <div >
                <div id="kslplus-headline1" className="kslplus-headline-main" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: "55px" }}>
                    <span>Dokumente</span>
                    {this.props.berichtErstellenAnzeigen && (this.props.verwaltungsansicht || this.props.designMode) &&
                        <button type="button" className="be-btn be-btn-dynamic" style={this.props.designMode ? { fontSize: "15px", padding: "5px 16px", whiteSpace: "nowrap", marginLeft: "20px" } : { fontSize: "16px", padding: "6px 18px" }} onClick={() => this.props.onBerichtKlick()}>Bericht erstellen</button>
                    }
                </div>
                <div className="kslplus-dokument-container">
                    <TreeView
                        className="kslplus-dokument-tree"
                        defaultCollapseIcon={<div className="kslplus-dokument-expand">-</div>}
                        defaultExpandIcon={<div className="kslplus-dokument-expand">+</div>}

                    >
                        {treeitems}
                        {docitems}
                    </TreeView>
                </div>
                <BerichtErstellen
                    open={this.props.berichtDialogOpen}
                    kunde={this.props.kunde}
                    gemeinde={this.props.gemeinde}
                    jahr={this.props.jahr}
                    plantyp={this.props.plantyp}
                    planstufe={this.props.planstufe}
                    uhconfig={this.props.uhconfig}
                    bundesland={this.props.bundesland}
                    buchungsart={this.props.buchungsart}
                    token={this.getToken()}
                    onClose={() => this.props.onBerichtDialogClose()}
                    onNeedsLogin={() => {
                        this.props.onBerichtDialogClose();
                        this.props.onBerichtKlick();
                    }}
                />
            </div>
        );
    }
}   